import { zodKnownFieldDefaultValidation } from '@juvare/platform-shared/features/validation';
import { z } from 'zod';
export const allFeatureTypes = [
    'credential',
    'deploymentAndPriorCommitments',
    'general',
    'licenseCheck',
    'medicalSpecialties',
    'occupations',
    'personalInformation',
    'skillsAndTrainings',
    'trainIntegration',
    'tribe',
];
export const licenseStatuses = [
    'multipleMatchesFound',
    'noMatchFound',
    'cvoExpired',
    'inactive',
    'verifiedExpirationUpdated',
    'expired',
    'notChecked',
    'missingFields',
    'readyToVerify',
    'pending',
    'verified',
    'notVerified',
    'outOfState',
];
export const licenseStatusSchema = z.enum(licenseStatuses);
export const oigStatuses = ['readyToVerify', 'pending', 'notVerified', 'verified'];
export const excludedDefaultLicenseStatuses = ['notChecked', 'missingFields', 'readyToVerify'];
export const defaultLicenseStatusFilters = licenseStatuses.filter((status) => !excludedDefaultLicenseStatuses.includes(status));
export const OccupationEcls = ['ecl4', 'ecl3', 'ecl2', 'ecl1', 'noEcl'];
export const personLicenseSchema = z.intersection(z.object({
    licenseId: z.string().uuid().optional(), // if not exists then automatically generated in PersonCredential entity onTransform
    hash: z.string().optional(),
    status: licenseStatusSchema.optional(),
    licenseNumber: z.string().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    issuingStateOrJurisdiction: z.string().optional(),
}), z.record(z.string(), z.any()));
export const personCredentialSchema = z.object({
    licenses: personLicenseSchema.array().optional(),
});
export const groupDataSchema = z.object({
    currentProfessionalStatusId: z.string().uuid().optional(),
    currentProfessionalStatus: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(), // Deprecated property. Use - currentProfessionalStatusId
});
export const personOccupationSchema = z.object({
    occupationId: z.string().uuid().optional(),
    occupationName: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(),
    groupId: z.string().uuid().optional(),
    groupName: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(),
    credentials: z
        .record(z.string(), personCredentialSchema)
        .refine(zodKnownFieldDefaultValidation.recordRefineCondition, zodKnownFieldDefaultValidation.recordRefineErrorMessage)
        .optional(),
    groupData: groupDataSchema.optional(),
    ecl: z.enum(OccupationEcls).optional(),
});
export const internalPersonLicenseDataChangeSchema = z.object({
    licenseId: z.string().uuid().optional(),
    status: licenseStatusSchema.optional(),
    oigStatus: z.enum(oigStatuses).optional(),
    licenseCheckRequestDate: z.number().optional(),
});
export const oigLicenseCheckRecordData = z.object({
    lastName: z.string(),
    firstName: z.string(),
    middleName: z.string(),
    businessName: z.string(),
    general: z.string(),
    specialty: z.string(),
    upin: z.string(),
    npi: z.string(),
    dateOfBirth: z.string(),
    address: z.string(),
    city: z.string(),
    state: z.string(),
    zip: z.string(),
    exclusionType: z.string(),
    exclusionDate: z.string(),
    reinstateDate: z.string(),
    waiverDate: z.string(),
    waiverState: z.string(),
});
export const licenseCheckResponseData = z.object({
    success: z.boolean(),
    message: z.string().optional(),
    licenseCheckResult: z
        .intersection(z.object({
        licenseNumber: z.string(),
        status: z.union([z.enum(['ACTIVE', 'INACTIVE', 'EXPIRED']), z.string()]),
        expirationDate: z.string().optional(),
        licensePrefix: z.string().optional(),
        dateOfBirth: z.string().optional(),
        message: z.string().optional(),
    }), z.record(z.string(), z.any()))
        .optional(),
    oigLicenseCheckResult: z
        .intersection(z.object({
        status: z.union([z.enum(['NO MATCH', 'MATCH']), z.string()]),
        // TODO: change to dateOfBirthUsed after PLAT-1350 resolved
        dobUsed: z.boolean(),
        records: oigLicenseCheckRecordData.array().optional(),
    }), z.record(z.string(), z.any()))
        .optional(),
});
export const internalPersonOccupationDataChangeSchema = z.object({
    usePreviousOccupations: z.boolean().optional(),
});
// TODO WidgetFormConfig has to be added in common form UI ( CUI-393 )
export const credentialFormConfigSchema = z.object({
    credentialId: z.string().min(1),
    name: z.string().min(1),
    form: z.any(),
    jasBoard: z.boolean(),
});
// TODO WidgetFormConfig has to be added in common form UI ( CUI-393 )
export const partialCredentialFormConfigSchema = credentialFormConfigSchema.omit({ form: true });
